import { initProductsSlider, productsSlider } from "./wpdp-products-slider.js";

document.addEventListener("DOMContentLoaded", function () {
  /* Configuraciones del slider de home [Discount products] */
  let sliderObjConfig2 = {
    slidesPerView: "auto",
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next-unique.section-discount-products",
      prevEl: ".swiper-button-prev-unique.section-discount-products",
    },
  };

  /* Inicializar el slider productos con descuentos de home */
  /* El de default */
  let sliderDiscountProductInit = initProductsSlider(
    "discount-products",
    sliderObjConfig2
  );
  /* Las demás categorias al dar click */
  productsSlider(
    "discount-products",
    sliderDiscountProductInit,
    sliderObjConfig2
  );
});
